import {
  LABORDENDIGITAL_ERROR,
  LABORDENDIGITAL_LOADING,
  LABORDENDIGITAL_SUCCESS,
  LABORDENDIGITAL_RESET,
  LABORDENDIGITAL_ALTATURNO_SET,
  LABORDENDIGITAL_LOAD,
  LABORDENDIGITAL_FLGVOLVER,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import labOrdenDigitalInitialState from "../initialStates/labOrdenDigitalInitialState";

const labOrdenDigital = (state, { payload, type }) => {
  switch (type) {
    case LABORDENDIGITAL_LOADING:
      return {
        ...state,
        labOrdenDigital: {
          ...state.labOrdenDigital,
          error: null,
          loading: true,
        },
      };
    case LABORDENDIGITAL_LOAD:
      return {
        ...state,
        labOrdenDigital: {
          ...state.labOrdenDigital,
          load: payload,
        },
      };
    case LABORDENDIGITAL_SUCCESS:
      return {
        ...state,
        labOrdenDigital: {
          ...state.labOrdenDigital,
          loading: false,
          error: null,
          data: payload,
        },
      };
    case LABORDENDIGITAL_ALTATURNO_SET:
      return {
        ...state,
        labOrdenDigital: {
          ...state.labOrdenDigital,
          loading: false,
          error: null,
          altaTurno: payload,
        },
      };
    case LABORDENDIGITAL_FLGVOLVER:
      return {
        ...state,
        labOrdenDigital: {
          ...state.labOrdenDigital,
          flgVolver: payload,
        },
      };
    case LABORDENDIGITAL_ERROR:
      return {
        ...state,
        labOrdenDigital: {
          ...state.labOrdenDigital,
          error: payload,
          loading: false,
        },
      };

    case LABORDENDIGITAL_RESET:
      return {
        ...state,
        labOrdenDigital: {
          ...state.labOrdenDigital,
          loading: false,
          error: null,
          data: null,
          altaTurno: null,
          load: false,
          pdf: null,
          flgVolver: false,
        },
      };

    case RESET_PORTAL_CONTEXT:
      return labOrdenDigitalInitialState;

    default:
      return state;
  }
};

export default labOrdenDigital;
